import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  templateUrl: './find-id.html',
  styleUrls: ['./find-id.scss'],
})

export class FindIdPage {
  /**
   * 사용자 이름
   */
  userName: string;

  /**
   * 사용자 아이디
   */
  userId: string;

  /**
   * @constructor
   */
  constructor(
    private $router: Router,

    private $activatedRoute: ActivatedRoute,
    private $location: Location) {
    this.$activatedRoute.params.subscribe((params) => {
      if (!params) return;
      this.userName = params['name'];
      this.userId = params['id'];
    });
  }

  /**
   * 로그인페이지로 이동
   */
  moveLoginPage() {
    this.$router.navigate(['']);
  }

  /**
   * 아이디/비밀번호 찾기 페이지로 이동
   */
  moveFindPrivacyPage() {
    this.$router.navigate(['/find-privacy']);
  }
}
